import React from 'react';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { Box } from './Box';
import { Typography } from './Typography';
import { ChevronLeft, ChevronRight } from './Icon';
import { styled } from './styled';

function PreviousIndicator(props) {
  const { sx = {}, ...iconProps } = props;
  return (
    <Box display='flex' flexDirection='row' flexWrap='nowrap' alignItems='center'>
      <Box display='flex' paddingLeft='1px'><ChevronLeft {...iconProps} sx={{ ...sx, fontSize: '24px !important' }} /></Box>
      <Typography variant='body2' marginLeft={1}>Previous</Typography>
    </Box>
  );
}

function NextIndicator(props) {
  const { sx = {}, ...iconProps } = props;
  return (
    <Box display='flex' flexDirection='row' flexWrap='nowrap' alignItems='center'>
      <Typography variant='body2' marginRight={1}>Next</Typography>
      <Box display='flex' paddingRight='1px'><ChevronRight {...iconProps} sx={{ ...sx, fontSize: '24px !important' }} /></Box>
    </Box>
  );
}

const StyledPagination = styled(Pagination)(() => ({
  '&.MuiPagination-root .MuiPagination-ul li': {
    minWidth: '20px',
  },
}));

const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
  '&.MuiPaginationItem-root.MuiButtonBase-root': {
    borderRadius: '2px',
    height: '22px',
    minWidth: '22px',
    margin: theme.spacing(0, 0.75),
    // border: '1px solid transparent',
    transition: 'color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '& .MuiTouchRipple-root': {
      color: theme.palette.secondary.light,
    },
    '&:hover': {
      // border: `1px solid ${theme.palette.secondary.veryLight}`,
      background: theme.palette.secondary.contrastText,
      color: theme.palette.secondary.main,
    },
    '&.Mui-selected': {
      background: theme.palette.secondary.veryLight,
      color: theme.palette.secondary.veryDark,
    },
  },
}));

function CustomizedPagination(props) {
  return (
    <StyledPagination
      shape='rounded'
      renderItem={(item) => (
        <StyledPaginationItem
          slots={{
            previous: PreviousIndicator,
            next: NextIndicator,
          }}
          {...item}
        />
      )}
      {...props}
    />
  );
}

export {
  Pagination,
  PaginationItem,
  CustomizedPagination,
};
